let NumberType = []
let activeButtonID = 0
let bettypeString = ''
let countofspots = 0
let gennumbersArray = []
let generateArray = []
let rateValue = 0
let numberOfDigitsf
let lengthNumner
let selectedPrefixes
export let generateGameNumbers = (numbersArray, selectNumberType, selectedABC, activeBatPrice) => {
  // straightWheel = single
  // duplicatesWheel = duplicatesWheel
  // triplesWheel = triple
  NumberType = selectNumberType
  activeButtonID = 0
  bettypeString = ''
  countofspots = 0
  gennumbersArray = []
  generateArray = []
  rateValue = activeBatPrice
  selectedPrefixes = selectedABC

  var numbersArray = [...numbersArray];
  let sizenum = numbersArray.length;

  if (sizenum == 1) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[0], numbersArray[0]);
  }

  if (sizenum == 2) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[0]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[0], numbersArray[1]);
  }

  if (sizenum == 3) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
  }

  if (sizenum == 4) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
  }

  if (sizenum == 5) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
  }

  if (sizenum == 6) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[5]);

  }

  if (sizenum == 7) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[6]);
  }

  if (sizenum == 8) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[7]);
  }

  if (sizenum == 9) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[6], numbersArray[7], numbersArray[8]);
  }

  if (sizenum == 10) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[6], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[6], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[6], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[7], numbersArray[8], numbersArray[9]);
  }

  return generateArray;
}

export function generateGameNumbersLuckyPick(numbersArray, selectNumberType, activeBatPrice) {
  NumberType = selectNumberType
  generateArray = []
  rateValue = activeBatPrice
  var numbersArray = [...numbersArray];

  let sizenum = numbersArray.length;
  // console.log('sizenum: ', sizenum);
  if (sizenum == 1) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[0], numbersArray[0]);
  }

  if (sizenum == 2) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[0]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[0], numbersArray[1]);
  }

  if (sizenum == 3) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
  }

  if (sizenum == 4) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
  }

  if (sizenum == 5) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
  }

  if (sizenum == 6) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[5]);
  }

  if (sizenum == 7) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[6]);
  }

  if (sizenum == 8) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[7]);
  }

  if (sizenum == 9) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[6], numbersArray[7], numbersArray[8]);
  }

  if (sizenum == 10) {
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[2]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[1], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[2], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[3], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[4], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[5], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[0], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[3]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[2], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[3], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[4], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[5], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[1], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[4]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[3], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[4], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[5], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[2], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[5]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[4], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[5], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[3], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[6]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[5], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[4], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[7]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[6], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[5], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[6], numbersArray[7], numbersArray[8]);
    genThreeNumber(selectedPrefixes, numbersArray[6], numbersArray[7], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[6], numbersArray[8], numbersArray[9]);
    genThreeNumber(selectedPrefixes, numbersArray[7], numbersArray[8], numbersArray[9]);
  }
  // console.log('generateArray: ', generateArray);
  return generateArray;
}

function genThreeNumber(selectedPrefixes, a, b, c) {

  let straightWheel = NumberType.includes('Single')
  let duplicatesWheel = NumberType.includes('Duplicates')
  let triplesWheel = NumberType.includes('Triples')

  if (straightWheel) {
    if (duplicatesWheel) {
      if (triplesWheel) {
        genThreeNumberFix(selectedPrefixes,a, b, c, 1);
        genThreeNumberFix(selectedPrefixes,a, c, b, 1);
        genThreeNumberFix(selectedPrefixes,b, a, c, 1);
        genThreeNumberFix(selectedPrefixes,b, c, a, 1);
        genThreeNumberFix(selectedPrefixes,c, b, a, 1);
        genThreeNumberFix(selectedPrefixes,c, a, b, 1);
        genThreeNumberFix(selectedPrefixes,a, a, a, 1);
        genThreeNumberFix(selectedPrefixes,b, b, b, 1);
        genThreeNumberFix(selectedPrefixes,c, c, c, 1);
        genThreeNumberFix(selectedPrefixes,a, a, b, 1);
        genThreeNumberFix(selectedPrefixes,b, a, a, 1);
        genThreeNumberFix(selectedPrefixes,a, b, a, 1);
        genThreeNumberFix(selectedPrefixes,a, a, c, 1);
        genThreeNumberFix(selectedPrefixes,c, a, a, 1);
        genThreeNumberFix(selectedPrefixes,a, c, a, 1);
        genThreeNumberFix(selectedPrefixes,b, b, c, 1);
        genThreeNumberFix(selectedPrefixes,c, b, b, 1);
        genThreeNumberFix(selectedPrefixes,b, c, b, 1);
        genThreeNumberFix(selectedPrefixes,b, b, a, 1);
        genThreeNumberFix(selectedPrefixes,b, a, b, 1);
        genThreeNumberFix(selectedPrefixes,a, b, b, 1);
        genThreeNumberFix(selectedPrefixes,c, c, a, 1);
        genThreeNumberFix(selectedPrefixes,a, c, c, 1);
        genThreeNumberFix(selectedPrefixes,c, a, c, 1);
        genThreeNumberFix(selectedPrefixes,c, c, b, 1);
        genThreeNumberFix(selectedPrefixes,b, c, c, 1);
        genThreeNumberFix(selectedPrefixes,c, b, c, 1);
      } else {
        genThreeNumberFix(selectedPrefixes,a, b, c, 1);
        genThreeNumberFix(selectedPrefixes,a, c, b, 1);
        genThreeNumberFix(selectedPrefixes,b, a, c, 1);
        genThreeNumberFix(selectedPrefixes,b, c, a, 1);
        genThreeNumberFix(selectedPrefixes,c, b, a, 1);
        genThreeNumberFix(selectedPrefixes,c, a, b, 1);
        genThreeNumberFix(selectedPrefixes,a, a, b, 1);
        genThreeNumberFix(selectedPrefixes,b, a, a, 1);
        genThreeNumberFix(selectedPrefixes,a, b, a, 1);
        genThreeNumberFix(selectedPrefixes,a, a, c, 1);
        genThreeNumberFix(selectedPrefixes,c, a, a, 1);
        genThreeNumberFix(selectedPrefixes,a, c, a, 1);
        genThreeNumberFix(selectedPrefixes,b, b, c, 1);
        genThreeNumberFix(selectedPrefixes,c, b, b, 1);
        genThreeNumberFix(selectedPrefixes,b, c, b, 1);
        genThreeNumberFix(selectedPrefixes,b, b, a, 1);
        genThreeNumberFix(selectedPrefixes,b, a, b, 1);
        genThreeNumberFix(selectedPrefixes,a, b, b, 1);
        genThreeNumberFix(selectedPrefixes,c, c, a, 1);
        genThreeNumberFix(selectedPrefixes,a, c, c, 1);
        genThreeNumberFix(selectedPrefixes,c, a, c, 1);
        genThreeNumberFix(selectedPrefixes,c, c, b, 1);
        genThreeNumberFix(selectedPrefixes,b, c, c, 1);
        genThreeNumberFix(selectedPrefixes,c, b, c, 1);
      }
    } else {
      if (triplesWheel) {
        genThreeNumberFix(selectedPrefixes,a, b, c, 1);
        genThreeNumberFix(selectedPrefixes,a, c, b, 1);
        genThreeNumberFix(selectedPrefixes,b, a, c, 1);
        genThreeNumberFix(selectedPrefixes,b, c, a, 1);
        genThreeNumberFix(selectedPrefixes,c, b, a, 1);
        genThreeNumberFix(selectedPrefixes,c, a, b, 1);
        genThreeNumberFix(selectedPrefixes,a, a, a, 1);
        genThreeNumberFix(selectedPrefixes,b, b, b, 1);
        genThreeNumberFix(selectedPrefixes,c, c, c, 1);

      } else {
        genThreeNumberFix(selectedPrefixes,a, b, c, 1);
        genThreeNumberFix(selectedPrefixes,a, c, b, 1);
        genThreeNumberFix(selectedPrefixes,b, a, c, 1);
        genThreeNumberFix(selectedPrefixes,b, c, a, 1);
        genThreeNumberFix(selectedPrefixes,c, b, a, 1);
        genThreeNumberFix(selectedPrefixes,c, a, b, 1);
      }
    }
  } else {
    if (duplicatesWheel) {
      if (triplesWheel) {
        genThreeNumberFix(selectedPrefixes,a, b, c, 2);
        genThreeNumberFix(selectedPrefixes,a, a, b, 2);
        genThreeNumberFix(selectedPrefixes,a, a, c, 2);
        genThreeNumberFix(selectedPrefixes,b, b, c, 2);
        genThreeNumberFix(selectedPrefixes,b, b, a, 2);
        genThreeNumberFix(selectedPrefixes,c, c, a, 2);
        genThreeNumberFix(selectedPrefixes,c, c, b, 2);
        genThreeNumberFix(selectedPrefixes,a, a, a, 2);
        genThreeNumberFix(selectedPrefixes,b, b, b, 2);
        genThreeNumberFix(selectedPrefixes,c, c, c, 2);
      } else {
        genThreeNumberFix(selectedPrefixes,a, a, b, 1);
        genThreeNumberFix(selectedPrefixes,b, a, a, 1);
        genThreeNumberFix(selectedPrefixes,a, b, a, 1);
        genThreeNumberFix(selectedPrefixes,a, a, c, 1);
        genThreeNumberFix(selectedPrefixes,c, a, a, 1);
        genThreeNumberFix(selectedPrefixes,a, c, a, 1);
        genThreeNumberFix(selectedPrefixes,b, b, c, 1);
        genThreeNumberFix(selectedPrefixes,c, b, b, 1);
        genThreeNumberFix(selectedPrefixes,b, c, b, 1);
        genThreeNumberFix(selectedPrefixes,b, b, a, 1);
        genThreeNumberFix(selectedPrefixes,b, a, b, 1);
        genThreeNumberFix(selectedPrefixes,a, b, b, 1);
        genThreeNumberFix(selectedPrefixes,c, c, a, 1);
        genThreeNumberFix(selectedPrefixes,a, c, c, 1);
        genThreeNumberFix(selectedPrefixes,c, a, c, 1);
        genThreeNumberFix(selectedPrefixes,c, c, b, 1);
        genThreeNumberFix(selectedPrefixes,b, c, c, 1);
        genThreeNumberFix(selectedPrefixes,c, b, c, 1);
      }

    } else {

      if (triplesWheel) {
        genThreeNumberFix(selectedPrefixes,a, a, a, 2);
        genThreeNumberFix(selectedPrefixes,b, b, b, 2);
        genThreeNumberFix(selectedPrefixes,c, c, c, 2);

      } else {
        genThreeNumberFix(selectedPrefixes,a, b, c, 2);

      }
    }
  }
}

function genThreeNumberFix(selectedPrefixes, a, b, c, bettype) {
    const pureNumber = `${a}${b}${c}`;
    const numberValue = a * 100 + b * 10 + c;

    if (activeButtonID == 0) {

        // prevent duplicate
        if (!gennumbersArray.includes(numberValue)) {

            // store base number
            gennumbersArray[countofspots] = numberValue;

            let bettypeString = "";
            if (bettype == 2) bettypeString = "BOX";
            if (bettype == 1) bettypeString = "STR";

            // if prefixes selected → create A123 B123 C123
            if (selectedPrefixes && selectedPrefixes.length > 0) {

                selectedPrefixes.forEach(prefix => {
                    generateArray.push({
                        number: prefix + pureNumber,
                        betType: bettypeString,
                        rateValue: rateValue
                    });
                });

            } else {
                // no prefix → only 123
                generateArray.push({
                    number: pureNumber,
                    betType: bettypeString,
                    rateValue: rateValue
                });
            }

            countofspots++;
        }
    }
}
